import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156f938b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "periodSelector" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "간편 검색", -1))
const _hoisted_3 = { class: "period-selector input-item" }
const _hoisted_4 = {
  key: 0,
  class: "options-wrap"
}
const _hoisted_5 = ["onClick"]

import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PeriodSelector',
  emits: ['setPeriodOption'],
  setup(__props, { emit }) {


/**** data -------------------- */
var isOn_periodSelect = ref(false);
var selectedOption = ref('기간');
var periodOptions = ref([
  { code: '00', name: '전체' },
  { code: '01', name: '오늘' },
  { code: '02', name: '1주일' },
  { code: '03', name: '1개월' },
  { code: '04', name: '3개월' },
]);
/**** methods ----------------- */
const onClick_period = () => {
  if (isOn_periodSelect.value) {
    isOn_periodSelect.value = false;
  } else {
    isOn_periodSelect.value = true;
  }
};
const onClick_periodOption = (item: { code: string; name: string }) => {
  selectedOption.value = item.name;
  emit('setPeriodOption', item);
  isOn_periodSelect.value = false;
};
const onClick_bg = () => {
  isOn_periodSelect.value = false;
};
/**** content -----------------
 * 간편 검색
 * /
 */
/**** hook -------------------- */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(isOn_periodSelect))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "selector-bg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick_bg()))
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["option-default", [{ on: _unref(isOn_periodSelect) === true }, { selected: _unref(selectedOption) !== '기간' }]]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick_period()))
      }, _toDisplayString(_unref(selectedOption)), 3),
      _createVNode(_Transition, { name: "selectOption" }, {
        default: _withCtx(() => [
          (_unref(isOn_periodSelect))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(periodOptions), (item) => {
                  return (_openBlock(), _createElementBlock("ul", {
                    class: "options",
                    key: item
                  }, [
                    _createElementVNode("li", {
                      class: "option-list",
                      onClick: ($event: any) => (onClick_periodOption(item))
                    }, _toDisplayString(item.name), 9, _hoisted_5)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})